import { detectMobile } from './helpers'

function mobileNav () {
	// don't go to parent menu-item on click
	if (detectMobile() === true) {
		const parents = document.querySelectorAll('.menu-item-has-children > a')
		for (let parent of parents) {
			parent.addEventListener('click', (e) => e.preventDefault())
		}
	}

	// Hamburger menu
	const toggle = document.querySelector('.menu-toggle')
	const nav = document.querySelector('.main-navigation')
	toggle.addEventListener('click', () => {
		nav.classList.toggle('active')
		toggle.classList.toggle('active')
	})
}

export default mobileNav
